export const INTERVAL_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'eightHours', label: '8 hours' },
  { value: 'twoHours', label: '2 hours' },
  { value: 'oneHour', label: '1 hour' },
  { value: '30mins', label: '30 mins' },
];

export const DEFAULT_INTERVAL = 'daily';

export const EVENT_CONFIG_INITIAL_STATE = {
  hubspotOrganizationSync: DEFAULT_INTERVAL,
  hubspotAccountSync: DEFAULT_INTERVAL,
  hubspotContactSync: DEFAULT_INTERVAL,
  hubspotNoteSync: DEFAULT_INTERVAL,
  hubspotActivitySync: DEFAULT_INTERVAL,
  hasUnSavedChange: false,
  persistedState: null,
  loading: false,
  error: null,
};
